import { createContext, useEffect, useRef, useState } from "react";
import { useAuth } from "../services/AuthService";

export const AppContext = createContext();
const AppProvider = ({children}) =>{
    const { user, setUser, isAuthenticated, login, logout } = useAuth();
    const [userProfile,setUserProfile] = useState();
    const [customerIotProfile,setCustomerIotProfile] = useState();
    const [selectedComponent,setSelectedComponent] = useState(null);

    const [maximizedComponent,setMaximizedComponent] = useState(null);
    const [iotRole,setIOTRole] = useState(null);
    const [showSideBar,setShowSideBar] = useState(false);
    const [thingsBoardProfile,setThingsBoardProfile] = useState(null);
    const [defaultDashboard,setDefaultDashboard] = useState(null);
    const [showBottomRightMessageBox,setShowBottomRightMessageBox] = useState(false);
    const [bottomRightMessageBoxMessage,setBottomRightMessageBoxMessage] = useState('');
    const [showLogoutAndAccountComponent,setShowLogoutAndAccountComponent] = useState(false);
    const mobileSideBarLauncherRef = useRef(null);
    const handleStorageChange = (e) =>{
        if(e.key === '#_blink_iot_portal_user'){
            setUser(e.newValue? JSON.parse(e.newValue):null);
        }
    };
    useEffect(() =>{
        if(!user){
            const savedUser = localStorage.getItem('#_blink_iot_portal_user');
            if(savedUser){
                setUser(JSON.parse(savedUser));
            }
        }
        window.addEventListener('storage',handleStorageChange);
        return () => window.removeEventListener('storage',handleStorageChange);
    },[]);
    useEffect(() =>{
        if(user) localStorage.setItem('#_blink_iot_portal_user',JSON.stringify(user));
        else localStorage.removeItem('#_blink_iot_portal_user');
    },[user]);
    return(
        <AppContext.Provider value={{
            user,isAuthenticated,login,logout,
            userProfile,setUserProfile,
            customerIotProfile,setCustomerIotProfile,
            selectedComponent,setSelectedComponent,

            maximizedComponent,
            setMaximizedComponent,
            iotRole,
            setIOTRole,
            showSideBar,
            setShowSideBar,
            thingsBoardProfile,
            setThingsBoardProfile,
            defaultDashboard,
            setDefaultDashboard,
            showBottomRightMessageBox,
            setShowBottomRightMessageBox,
            bottomRightMessageBoxMessage,
            setBottomRightMessageBoxMessage,
            mobileSideBarLauncherRef,
            showLogoutAndAccountComponent,
            setShowLogoutAndAccountComponent
        }}>{children}</AppContext.Provider>
    )
};
export default AppProvider;